export const TOOGLE_DRAWER = 'TOOGLE_DRAWER';

export const toogleDrawer = ()=>({
    type: TOOGLE_DRAWER
});